import {planOf} from "home/gating";
import type {OfferLadderMessages} from "i18n/en/offerLadder";
import type {PricingMessages} from "i18n/en/pricing";

/** The catalog entries the line is built from, derived from the catalogs rather than restated. */
export interface UpgradeChargeCopy {
	planNames: PricingMessages["pricing"]["planNames"];
	sentence: OfferLadderMessages["offerLadder"]["gift"]["upgradeCharge"];
}

/**
 * The line a live subscriber reads in the coupon claim dialog directly above the order button, before
 * the Terms link (owner decisions on kitecorp/transferify-ui#3389 and #3396, 2026-10-08 and 2026-10-09):
 * the plan the account is on now, VAT and cancellation.
 *
 * The amount the press charges is on the order button only ("Upgrade for €4.20"), never repeated here.
 * It is the api's prorated preview of the plan change, which credits the unused part of the current plan
 * against the new one, so it differs from the coupon's first-month price on the same screen; naming the
 * plan the account is on now is what explains the credit. The coupon does not reduce that charge: the api
 * charges the plain proration and only then attaches the coupon, without prorating, so a one-month coupon
 * discounts the next regular invoice, the first full month on the new plan
 * (kitecorp/transferify-api-service#2580). The plan is read through {@link planOf}, the one rule every
 * capability gate uses, and never from the coupon, whose plan is the TARGET.
 *
 * React-free (`logic-outside-react`): it takes the catalog's own entries, as `pricing/planChangeCopy`
 * does, so the sentence is unit-tested in every locale without rendering.
 */
export function upgradeChargeLine(account: Parameters<typeof planOf>[0], copy: UpgradeChargeCopy): string {
	return copy.sentence(copy.planNames[planOf(account)]);
}
